import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { Box, IconButton, Skeleton, ToggleButton, ToggleButtonGroup, Typography, useTheme } from '@mui/material';
import { Add, ArrowDownward, ArrowUpward, Edit } from '@mui/icons-material';

import { Table, usePagination } from '@frontend/features/common/components/Table';
import { ListLayout } from '@frontend/features/common/components/ListLayout';
import { TABLE_HEIGHT_WITH_AGENCIES_LAYOUT } from '@frontend/features/agencies/constants';

import { routes } from '../routes';
import { SearchInput } from '../../features/common/components/SearchInput/SearchInput';

const data = {
  items: [
    {
      id: 1,
      name: 'default',
      markup: '8%+ imp',
      order: 1,
    },
    {
      id: 2,
      name: 'Test 1',
      markup: '12% imp incluido',
      order: 2,
    },
    {
      id: 3,
      name: 'default',
      markup: '8%+ imp',
      order: 3,
    },
    {
      id: 4,
      name: 'default',
      markup: '8%+ imp',
      order: 4,
    },
    {
      id: 5,
      name: 'default',
      markup: '8%+ imp',
      order: 5,
    },
    {
      id: 6,
      name: 'default',
      markup: '8%+ imp',
      order: 6,
    },
    {
      id: 7,
      name: 'default',
      markup: '8%+ imp',
      order: 7,
    },
    {
      id: 8,
      name: 'default',
      markup: '8%+ imp',
      order: 8,
    },
  ],
  count: 12,
};

const isLoading = false;

export const AirRoutingRules = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { id } = useParams();
  const pagination = usePagination();
  const navigate = useNavigate();

  const itemsCount = data?.items.length ?? 0;

  return (
    <ListLayout padding={0} title="Air routing rules" subtitle="Air routing rules list">
      <Box display="flex" alignItems="center" gap={theme.spacing(3)} marginBottom={theme.spacing(3)}>
        <Typography
          variant="subtitle1"
          align="left"
          color={theme.palette.text.primary}
          sx={{
            flexGrow: 1,
          }}
        >
          {itemsCount} {t('common.results')}
        </Typography>
        <SearchInput placeholder={t('common.search')} onSearch={() => {}} />
        <ToggleButtonGroup
          exclusive
          sx={{
            height: theme.spacing(5),
            '& button': {
              padding: theme.spacing(1),
              width: theme.spacing(5),
            },
          }}
        >
          {id && (
            <ToggleButton
              onClick={() =>
                navigate(
                  `${routes.dashboard.agencyView.root.replace(':id', id)}/${
                    routes.dashboard.agencyView.markupRulesView
                  }`,
                )
              }
              value="add"
              aria-label="right aligned"
            >
              <Add />
            </ToggleButton>
          )}
        </ToggleButtonGroup>
      </Box>
      <Table
        height={TABLE_HEIGHT_WITH_AGENCIES_LAYOUT}
        columns={[
          {
            id: 'name',
            label: 'Nombre',
            align: 'left',
          },
          {
            id: 'markup',
            label: 'Markup',
            align: 'left',
          },
          {
            id: 'order',
            label: 'Order',
            align: 'center',
          },
          { id: 'actions', label: '', align: 'right' },
        ]}
        data={{
          key: 'id',
          items: data.items
            ? data.items.map((elItem) => ({
              ...elItem,
              name: (
                <Link
                  to={`${routes.dashboard.agencyView.root.replace(':id', String(id))}/${
                    routes.dashboard.agencyView.airRoutingRulesView
                  }`}
                >
                  {elItem.name}
                </Link>
              ),
              markup: elItem.markup,
              order: (
                <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
                  <IconButton>
                    <ArrowUpward />
                  </IconButton>
                  {elItem.order}
                  <IconButton>
                    <ArrowDownward />
                  </IconButton>
                </Box>
              ),
              actions: (
                <Box>
                  {id && (
                    <IconButton
                      onClick={() =>
                        navigate(
                          `${routes.dashboard.agencyView.root.replace(':id', id)}/${
                            routes.dashboard.agencyView.airRoutingRulesView
                          }`,
                        )
                      }
                    >
                      <Edit color="primary" />
                    </IconButton>
                  )}
                </Box>
              ),
            }))
            : [],
          totalCount: data?.count || 0,
        }}
        pagination={pagination}
        stickyHeader
      />

      {isLoading && <Skeleton height={theme.spacing(10)} variant="rounded" animation="wave" />}
    </ListLayout>
  );
};
